import { DsChart } from './ds-chart.class';
import { ChartOptions } from 'chart.js';
import { DsChartInterface } from '../interfaces/ds-chart.interface';
import { getElements, getNewYAxis } from '../functions/ds-charts.functions';
import { DsChartCustomOptions } from '../interfaces/ds-chart-custom-options.interface';

export class DsBarChart extends DsChart {
  /**
   * Creates an instance of DsBarChart.
   *
   * @param language the current language
   * @memberof DsBarChart
   */
  constructor(language = 'en') {
    super(language);
    this.chartType = 'bar';
  }

  /**
   * Overload of base class function. Init chart for line time chart.
   *
   * @param chart the current chart
   */
  public initChart(chart: DsChartInterface) {
    const options = this.getBarChartOptions(chart.customOptions);
    chart.options = options;
    super.initChart(chart);
  }

  /**
   * Get chart options for time chart.
   *
   * @param customOptions Custom options for the chart
   * @returns ChartOptions
   */
  private getBarChartOptions(customOptions: DsChartCustomOptions = {}): ChartOptions {
    const options: ChartOptions = this.getMergedOptions(customOptions);
    options.elements = getElements(customOptions.fill, customOptions.tension);
    options.scales.xAxes = [
      {
        stacked: customOptions.stacked,
        position: customOptions.xPosition || 'top',
        gridLines: {
          display: customOptions.xGrid,
          drawOnChartArea: false,
        },
        ticks: {
          min: 0,
          max: customOptions.isPercentage ? 100 : undefined,
          display: customOptions.xLabels,
        },
      },
    ];
    const yAxis: Chart.ChartYAxe = getNewYAxis(customOptions, false);
    yAxis.ticks.min = 0;
    options.scales.yAxes = [yAxis];

    options.layout = {
      padding: {
        bottom: 50,
      },
    };
    return options;
  }
}
